import React, { useState, useEffect } from "react";
import useSWR from "swr";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "./modal.css";
import _ from "lodash";
import { URLS } from "../../../Services/Urls";
import { API } from "../../../Services/axios";
import { productService } from "../../../Services/product.service";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { FaLongArrowAltRight } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import {
  clearProducts,
} from "../../../Redux/Store/Slices/productReducer";

import {
  updateSection,
} from "../../../Redux/Store/Slices/projectReducer";



import {
  addProduct,
  resetActiveSection,
  removeProduct,
  setActiveSection,
} from "../../../Redux/Store/Slices/sectionSlice";
import { getFallbackImageUrl, getProductImageUrl } from "../../../utils/productImage";

//const fetcher = url => API.get(url).then(res => res.data)
const ModalForm = ({ onShowSelectedProducts, sectionId }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [totalPages, setTotalPages] = useState(440);
  const dispatch = useDispatch();
  // const selectedProducts = useSelector(
  //   (state) => state.products.selectedProducts
  // );
  const { active_section } = useSelector((state) => state.section);
  const selectedProducts = useSelector((state) => {
    const products = state.section.active_section?.products;
    return Array.isArray(products) ? products : [];
  });
  // const selectedProducts = useSelector((state) => state.products.sections[sectionId] || []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedOption, setSelectedOption] = useState(""); // State to hold the selected option
  const [allProducts, setAllProducts] = useState([]);
  const [loadingAllProducts, setLoadingAllProducts] = useState(false);
  const [showAllProducts, setShowAllProducts] = useState(false);

  // Debug: surveiller les changements de selectedProducts
  useEffect(() => {
    console.log('selectedProducts a changé:', selectedProducts);
    console.log('active_section.products:', active_section?.products);
  }, [selectedProducts, active_section?.products]);

  // Fonction pour charger tous les produits
  const loadAllProducts = async () => {
    try {
      setLoadingAllProducts(true);
      const data = await productService.getAllProducts(query);
      setAllProducts(data.items || []);
      setShowAllProducts(true);
      console.log('Tous les produits chargés:', data.items?.length);
    } catch (error) {
      console.error('Erreur lors du chargement de tous les produits:', error);
    } finally {
      setLoadingAllProducts(false);
    }
  };

  const {
    data: products,
    error,
    isLoading,
    mutate,
  } = useSWR(URLS.PRODUCT.getProduct(query, currentPage));

  //const search_criteria = products?.search_criteria
  const { total_pages, next, previous } = products || {};

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setCurrentPage(1);
    await mutate();
  };

  const handleOpenModal = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    setSelectedOption("");
    
  };

  const handleSelectProduct = (product) => {
    console.log('handleSelectProduct appelé avec:', product);
    console.log('active_section avant addProduct:', active_section);
    
    const productContent = {
      id: _.uniqueId(),
      product_type: "LAMBOURDE", // Valeur par défaut
      product: product,
    }
    
    console.log('productContent à ajouter:', productContent);
    dispatch(addProduct(productContent));
    
    console.log('addProduct dispatché');
  };

  const handleRemoveProduct = (product) => {
    console.log('handleRemoveProduct appelé avec:', product);
    console.log('active_section avant removeProduct:', active_section);
    
    // Utiliser l'ID existant du produit au lieu d'en créer un nouveau
    const productContent = {
      id: product.id, // Utiliser l'ID existant
      product_type: product.product_type || "",
      product: product.product,
    }
    
    console.log('productContent à supprimer:', productContent);
    dispatch(removeProduct(productContent));
    
    console.log('removeProduct dispatché');
  }
  

  // const handleSelectProduct = (product, sectionId) => {
  //   const dispatch = useDispatch();
  //   const selectedProducts = useSelector((state) => state.products.sections[sectionId] || []);

  //   const isAlreadySelected = _.some(selectedProducts, { 'id': product.id });

  //   if (isAlreadySelected) {
  //     dispatch(removeProduct({ sectionId: sectionId, productId: product.id }));
  //   } else {
  //     dispatch(addProduct({ sectionId: sectionId, product }));
  //   }
  // };

  // const handleSelectProductWrapper = (product, sectionId) => {
  //   const sectionId = sectionId
  //   handleSelectProduct(product, sectionId)
  // }

  const handleAddProducts = async () => {
    try {
      console.log('selectedProducts dans handleAddProducts:', selectedProducts);
      console.log('active_section dans handleAddProducts:', active_section);
      console.log('selectedProducts.length:', selectedProducts?.length);
      
      if (!selectedProducts || selectedProducts.length === 0) {
        console.warn('Aucun produit sélectionné');
        return;
      }

      // Vérifier si c'est une section imbriquée (nested section)
      const isNestedSection =
        active_section?.isNestedSection === true ||
        active_section?.section_type === 'NESTED' ||
        active_section?.nested_section === true;

      const selectedList = Array.isArray(selectedProducts)
        ? [...selectedProducts]
        : [];

      const uniqueSelectedList = _.uniqBy(
        selectedList,
        (product) => product.product?.id || product.id
      );

      if (uniqueSelectedList.length === 0) {
        const { toast } = await import("react-toastify");
        toast.info("Veuillez sélectionner au moins un produit.");
        return;
      }

      const persistedIds = new Set(
        (active_section.initialProductIds || []).filter(Boolean)
      );

      const newlyAddedProducts = uniqueSelectedList.filter(
        (prod) => !persistedIds.has(prod.product?.id || prod.id)
      );

      if (newlyAddedProducts.length === 0) {
        console.log("Aucun nouveau produit à ajouter pour cette section");
        const { toast } = await import("react-toastify");
        toast.info("Aucun nouveau produit à ajouter pour cette section.");
        return;
      }

      const requestData = {
        section_id: active_section.id,
        products: newlyAddedProducts.map((product) => ({
          product: product.product.id,
          product_type: product.product_type || "LAMBOURDE",
        })),
      };

      console.log(
        `Données envoyées à l'API (${isNestedSection ? "section imbriquée" : "section"}) :`,
        requestData
      );

      const response = await API.post(
        URLS.PROJECT.addContentProducts,
        requestData
      );
      console.log(
        `Réponse API (${isNestedSection ? "section imbriquée" : "section"}) :`,
        response.data
      );

      const newContent = {
        id: _.uniqueId(),
        content_products: newlyAddedProducts.map((product) => ({
          id: _.uniqueId(),
          product: product.product.id,
          product_type: product.product_type || "LAMBOURDE",
        })),
      };

      const combinedProducts = _.uniqBy(
        [...uniqueSelectedList],
        (prod) => prod.product?.id || prod.id
      );

      const updatedInitialProductIds = _.uniq([
        ...Array.from(persistedIds),
        ...newlyAddedProducts
          .map((product) => product.product?.id || product.id)
          .filter(Boolean),
      ]);

      const updatedSection = {
        ...active_section,
        products: combinedProducts,
        content: [...(active_section.content || []), newContent],
        initialProductIds: updatedInitialProductIds,
      };

      const sectionToPersist = _.omit(updatedSection, [
        "isNestedSection",
        "initialProductIds",
      ]);

      dispatch(updateSection(sectionToPersist));
      dispatch(
        setActiveSection({
          ...updatedSection,
          isNestedSection,
          initialProductIds: updatedInitialProductIds,
        })
      );

      onShowSelectedProducts(updatedSection.products);

      const { toast } = await import("react-toastify");
      toast.success(
        `${newlyAddedProducts.length} produit(s) ajouté(s) ${
          isNestedSection ? "à la section imbriquée" : ""
        } avec succès !`
      );
    } catch (error) {
      console.error('Erreur lors de l\'ajout des produits:', error);
      const { toast } = await import('react-toastify');
      toast.error('Erreur lors de l\'ajout des produits');
    }
  };

  return (
    <>
      <div>
        <div
          className="modal fade"
          id={`exampleModal-${sectionId}`}
          tabIndex="-1"
          aria-labelledby={`exampleModalLabel-${sectionId}`}
          aria-hidden="true"
        >
          {" "}
          <div className="modal-dialog modal-xl modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add Products ({active_section.name})
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="input-group justify-content-center">
                    <div className="form-outline">
                      <input
                        style={{ width: "500px" }}
                        type="search"
                        id="form1"
                        className="form-control"
                        placeholder="Search for product..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                      />
                    </div>
                    <button type="submit" className="btn btn-primary">
                      Search
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-success ms-2"
                      onClick={loadAllProducts}
                      disabled={loadingAllProducts}
                    >
                      {loadingAllProducts ? 'Chargement...' : 'Charger tous les produits'}
                    </button>
                    {showAllProducts && (
                      <button 
                        type="button" 
                        className="btn btn-secondary ms-2"
                        onClick={() => setShowAllProducts(false)}
                      >
                        Voir par pages
                      </button>
                    )}
                  </div>
                </form>

                {isLoading && <p className="text-center">Loading...</p>}
                {error && (
                  <p className="text-center">Failed to load products</p>
                )}

                <div className="py-3">
                  {active_section?.products?.map((prod) => {
                    const imageUrl =
                      getProductImageUrl(prod.product) ||
                      getFallbackImageUrl();

                    return (
                      <span
                        className=" m-2 p-3  border d-inline-block "
                        style={{ width: "325px" }}
                        key={"selected-" + prod.product.id}
                      >
                        <div className="d-flex justify-content-between ">
                          <div style={{ width: "50px", height: "50px" }}>
                            <img
                              src={imageUrl}
                              className="img-fluid h-100"
                              alt={prod.product.name}
                            />
                          </div>
                          <div className="w-50 ps-2">{prod.product.name}</div>
                          <button
                            type="button"
                            className="btn-x border-0"
                            onClick={() => handleRemoveProduct(prod)}
                          >
                            <i className=" bi bi-x-circle-fill"></i>
                          </button>
                        </div>
                      </span>
                    );
                  })}
                </div>

                <div className="row">
                  {!isLoading &&
                    !loadingAllProducts &&
                    (showAllProducts ? allProducts : products?.items)?.map((product) => {
                      const productImage =
                        getProductImageUrl(product) || getFallbackImageUrl();

                      return (
                        <div
                          key={product.id}
                          className="modal-pointer col-md-3 col-sm-6 col-12 px-3 mb-5"
                          onClick={() => {
                            handleSelectProduct(product);
                            handleOpenModal(product);
                          }}
                        >
                          <div
                            className={`product-card pt-3 h-100 ${
                              _.filter(active_section?.products, function (o) {
                                return o.product.id === product.id;
                              }).length > 0
                                ? "active border-success"
                                : ""
                            }`}
                          >
                            <div className="d-flex flex-column">
                              <div className="image border mx-3 pb-3 flex-grow-1">
                                <img
                                  src={productImage}
                                  className="img-fluid h-100"
                                  alt={product.name}
                                />
                              </div>
                              <div className="description p-3 flex-grow-1 d-flex flex-column justify-content-between">
                                <p className="product-name mb-3">
                                  {product.name}
                                </p>
                                <div className="d-flex justify-content-between align-items-center">
                                  <p className="product-info mb-0">
                                    Price: £{product.price}
                                  </p>
                                  <div className="checkbox-container">
                                    <input
                                      type="checkbox"
                                      className="custom-checkbox"
                                      checked={
                                        _.filter(
                                          active_section?.products,
                                          function (o) {
                                            return o.product.id === product.id;
                                          }
                                        ).length > 0
                                      }
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/*modal dialog*/}
                            {/* {selectedProduct  && selectedProduct.id === product.id && (
                          <div
                            className={`modal fade ${isModalOpen ? 'show' : ''}`}
                            id={`product-modal-${product.id}`}
                            tabIndex="-1"
                            aria-labelledby={`product-modal-label-${product.id}`}
                            aria-hidden="false"
                            style={{display: isModalOpen ? 'block' : 'none', marginTop: '200px'}}
                          >
                            <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id={`product-modal-label-${product.id}`}>
                                Add Content
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={handleCloseModal}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                                  <div className="form-group">
                                    <select
                                      id="dropdown"
                                      className="form-control"
                                      value={selectedOption}
                                      onChange={handleSelectOption}
                                    >
                                      <option value="">Select a Product Type</option>
                                      <option value="LAMBOURDE">LAMBOURDE</option>
                                      <option value="BANDE_BITUMINEUSE">BANDE_BITUMINEUSE</option>
                                      <option value="CALE_VENTILATION">CALE_VENTILATION</option>
                                      <option value="VISERIE">VISERIE</option>
                                      <option value="PLOTS_DAKOTA">PLOTS_DAKOTA</option>
                                      <option value='CALE_D"ISOLATION '>CALE_D"ISOLATION</option>
                                      <option value="GEOTEXTILE">GEOTEXTILE</option>
                                      <option value="FORET_POUR_PRE_PREÇAGE">FORET_POUR_PRE_PREÇAGE</option>
                                      <option value="TRAITS_DÉCOUP">TRAITS_DÉCOUP</option>
                                      <option value="ESPACEUR_&_KIT_SERRE_LAME">ESPACEUR_&_KIT_SERRE_LAME</option>

                                    </select>
                                    <div className="mt-2">
                                      
                                    </div>
                                  </div>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      data-bs-dismiss="modal"
                                      onClick={() => {
                                        handleSelectProduct({...selectedProduct, product_type: selectedOption});
                                        handleCloseModal();
                                      }}                                    >
                                      Select
                                    </button>
                                  </div>
                                </div>
                            </div>
                          </div>
                          
                        )} */}
                        </div>
                      </div>
                    )})}
                </div>
                {!showAllProducts && (
                  <div className="d-flex pt-5 justify-content-evenly">
                    <div className="d-flex justify-content-evenly">
                      <ReactPaginate
                      previousLabel={
                        <button
                          type="button"
                          className=" btn prev-label "
                          style={{
                            backgroundColor: "lightgray",
                            color: "white",
                          }}
                        >
                          <FaLongArrowAltLeft />
                        </button>
                      }
                      nextLabel={
                        <button
                          type="button"
                          className="next-label btn"
                          style={{ backgroundColor: "green", color: "white" }}
                        >
                          <FaLongArrowAltRight />
                        </button>
                      }
                      breakLabel={"..."}
                      pageCount={totalPages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      pageLinkClassName="page-link mx-2"
                      activeLinkClassName="active-link"
                      style={{ textDecoration: "" }}
                    />
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn " data-bs-dismiss="modal">
                  Fermer
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAddProducts}
                  data-bs-dismiss="modal"
                >
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalForm;
